<template>
  <div id="login">
    <v-card>
      <h2>{{ $t("login_title") }}</h2>
      <div id="login-message" v-if="serverErrors.length > 0">
        <div v-for="(error, index) in serverErrors" :key="index">
          {{ error.message }}
        </div>
      </div>
      <v-form ref="form" v-model="isFormValid" @submit.prevent="onSubmit">
        <v-text-field
          v-model="user.credentials.email"
          :rules="[rules.required, rules.email]"
          outlined
          dense
          label="Email"
        />
        <v-text-field
          v-model="user.credentials.password"
          :rules="[rules.required]"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          class="my-1"
          outlined
          dense
          label="Heslo"
          @click:append="showPassword = !showPassword"
        />
        <v-checkbox
          v-model="user.stay_signed_in"
          :label="$t('stay_login')"
          class="mt-0"
          color="#324c8d"
        />
        <v-btn :loading="loading" class="login-btn" type="submit">{{
          $t("login")
        }}</v-btn>
      </v-form>
      <div class="link-wrapper">
        <router-link to="registrace">{{ $t("new_registration") }}</router-link>
        <router-link to="/zapomenute-heslo">{{
          $t("forgot_password")
        }}</router-link>
      </div>
    </v-card>
  </div>
</template>

<script>
import { setAuthInfo } from "@/utils/localStorageUtils.js";

export default {
  data() {
    return {
      user: {
        credentials: {
          email: "",
          password: ""
        },
        stay_signed_in: true
      },
      invalidLogin: true,
      isFormValid: true,
      showPassword: false,
      serverErrors: [],
      rules: {
        required: value => !!value || this.$t("validate_required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("validate_email");
        }
      },
      loading: false
    };
  },
  methods: {
    async loginUser() {
      try {
        this.loading = true;
        const { body: authInfo } = await this.$http.post(
          "doctors/signin",
          this.user
        );
        setAuthInfo(authInfo);
        this.$store.commit("setAuthenticated", true);
        this.$store.commit("setAccessToken", authInfo.auth.access_token);
        this.$store.commit(
          "setAccessTokenExpiresAt",
          authInfo.auth.access_token_expires_at
        );
        await this.$router.push({ name: "kalkulator" });
      } catch (error) {
        if (error.status >= 500) {
          // eslint-disable-next-line no-console
          console.error("Server error");
        } else {
          this.serverErrors = error.data.errors;
        }
      } finally {
        this.loading = false;
      }
    },
    onSubmit() {
      this.$refs.form.validate();
      if (this.isFormValid) {
        this.loginUser();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#login {
  .v-card {
    padding: 2rem;
    max-width: 25rem;
    margin: auto;
    box-shadow: 0px 0px 18px 0px #d1d1d1;

    ::v-deep .v-input__control {
      .primary--text {
        color: #324c8d !important;
        caret-color: #324c8d !important;
      }
    }
  }

  .v-form {
    margin-top: 2rem;
  }

  #login-message {
    margin-top: 1rem;
    padding: 1rem 0.7rem;
    font-size: 0.9rem;
    background: rgb(253, 192, 192);
    color: rgb(134, 0, 0);
  }

  .login-btn {
    width: 100%;
    background: #324c8d;
    color: white;
  }

  .link-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
  }

  @media only screen and (max-width: 500px) {
    padding: 16px 5px;
  }

  @media only screen and (max-width: 345px) {
    .link-wrapper {
      flex-direction: column;
      text-align: center;

      :first-child {
        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>
